"use client";

import { RetrievedPartner, RetrievedPartnerFullProfile, RetrievedProductCategory, RetrievedProductOverview } from "@/lib/sanity/responseTypes";
import { useEffect, useState } from "react";
import NavigationFilters from "../NavigationFilters";
import { useLocale } from "next-intl";
import { Link } from "@/i18n/navigation";
import { AllProductsReturnType } from "@/lib/server/shop/products/all-products";
import { ProductInfo } from "@/types";

interface PartnerCatalogueProps {
  sellsAllProducts?: boolean;
  catalogue: AllProductsReturnType;
  products: RetrievedPartnerFullProfile["products"];
}

export default function (props: PartnerCatalogueProps) {
  const locale = useLocale();
  const categories = props.catalogue.productsCategories;

  const productsList = props.catalogue.productsWithPrice
  const productsMap: Record<number, ProductInfo> = productsList.reduce((acc, val) => {
    acc[val.articleId] = val;
    return acc;
  }, {} as Record<number, ProductInfo>);

  const [currentCategory, setCurrentCategory] = useState<RetrievedProductCategory | null>(null);
  const [currentProductsSlice, setCurrentProdutsSlice] = useState<ProductInfo[]>(productsList);

  const [navigationFiltersItems, setNavigationFiltersItems] = useState<{
    label: string,
    doNotTranslate?: boolean,
    active: boolean,
    path?: string,
    onClick?: () => void,
  }[]>([]);

  useEffect(() => {
    let filterItems = [
      { label: "categories_all", active: currentCategory === null, onClick: () => setCurrentCategory(null) },
    ]
    let filterItemsCategories = categories.map((p, i) => {
      let relevantName = p.title[locale];
      return {
        label: relevantName,
        doNotTranslate: true,
        active: currentCategory?.slug === p.slug,
        onClick: () => setCurrentCategory(p),
      };
    })

    filterItems = filterItems.concat(filterItemsCategories);
    setNavigationFiltersItems(filterItems);
  }, [locale, categories, currentCategory]);

  useEffect(() => {
    if (currentCategory) {
      let relevantFullProductSet: RetrievedProductOverview[]
      if (props.sellsAllProducts) {
        relevantFullProductSet = props.catalogue.products;
      } else {
        relevantFullProductSet = props.products || [];
      }

      let newProductsSlice = relevantFullProductSet.filter(p => {
        let relevantCategory = p.category.find(c => c.slug === currentCategory.slug);
        return relevantCategory ? true : false;
      });

      newProductsSlice.forEach(p => {
        if (!productsMap[p.code]) {
          console.log(`Cannot find product with product code ${p.code}`);
        }
      });

      setCurrentProdutsSlice(newProductsSlice.map(p => productsMap[p.code]).filter(p => p !== undefined))
    } else {
      if (props.sellsAllProducts) {
        setCurrentProdutsSlice(productsList)
      } else {
        (props.products || []).forEach(p => {
          if (!productsMap[p.code]) {
            console.log(`Cannot find product with product code ${p.code}`);
          }
        });
        setCurrentProdutsSlice((props.products || []).map(p => productsMap[p.code]).filter(p => p !== undefined));
      }
    }
  }, [currentCategory, props.products, props.sellsAllProducts, productsList, categories]);

  return (
    <div className="flex flex-col py-4 gap-2.5 font-[Outfit]">
      <NavigationFilters items={navigationFiltersItems} translationCollection={"Category"} />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-x-[30px] gap-y-5 overflow-y-scroll max-h-[60vh]">
        {currentProductsSlice.map((p, i) => {
          return (
            <Link key={`product-${i}`} href={p.productPageUrl} className="flex flex-col gap-2.5">
              <img src={p.imgSrc[0]!} alt={p.name} className="aspect-21/25 rounded-2xl w-full max-h-full object-cover" />
              <div className="font-medium leading-[120%] w-full">{p.name}</div>
              <div className="text-sm leading-[120%] w-full">{p.description}</div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
